<template>
  <div class="type-group">
    <div
      class="type-content"
      v-for="item in options"
      :key="item.type"
      @click="$emit('input', item.type)"
      :class="{ active: value === item.type }"
    >
      <div
        v-if="item.type !== 'leftOneRightThree'"
        class="type-box"
        :class="item.type"
      >
        <div v-for="i in item.count" :key="i"></div>
      </div>

      <!-- 最后一种实现需要嵌套 -->
      <div class="type-box" :class="item.type" v-else>
        <div></div>
        <div>
          <div v-for="i in item.count - 1" :key="i"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      default: "oneLineOne"
    },
    options: {
      type: Array,
      default: () => {
        return [];
      }
    }
  }
};
</script>

<style lang="less" scoped>
.type-group {
  display: flex;
  flex-wrap: wrap;
  .type-content {
    padding: 0;
    width: 56px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid #eeeeee;
    cursor: pointer;
    .type-box {
      display: flex;
      div {
        background: #c5c5c5;
      }
    }
    .oneLineOne {
      > div {
        width: 20px;
        height: 9px;
      }
    }
    .oneLineTwo {
      > div {
        width: 9px;
        height: 20px;
      }
      > :first-child {
        margin-right: 2px;
      }
    }

    .oneLineThree {
      width: 22px;
      justify-content: space-between;
      > div {
        width: 6px;
        height: 20px;
      }
    }

    .oneLineFour {
      width: 22px;
      justify-content: space-between;
      > div {
        width: 4px;
        height: 20px;
      }
    }

    .leftOneRightTwo,
    .leftTwoRightOne {
      width: 20px;
      height: 20px;
      flex-direction: column;
      flex-wrap: wrap;
      justify-content: space-between;
      > div {
        width: 9px;
        height: 9px;
      }
      > div:first-child {
        height: 20px;
      }
    }

    .leftTwoRightOne {
      flex-direction: column-reverse;
      flex-wrap: wrap-reverse;
    }

    .leftOneRightThree {
      width: 20px;
      justify-content: space-between;
      > div:first-child {
        width: 9px;
        height: 20px;
      }
      > div:last-child {
        width: 9px;
        height: 20px;
        display: flex;
        flex-wrap: wrap;
        background: transparent;
        > div:first-child {
          width: 9px;
          height: 9px;
          margin-bottom: 2px;
        }
        > div:nth-child(2),
        div:last-child {
          width: 4px;
          height: 9px;
        }
        > div:last-child {
          margin-left: 1px;
        }
      }
    }
  }
  .active {
    border: 1px solid #2154f4;
    .type-box {
      display: flex;
      div {
        background: #2154f4;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/myviews/shoppMall/activityPageSet/fullPlatformSetQuery/lowCode/custom-component/baseComponents/Cube/components/TypeGroup.vue